import { useApi, API_ENDPOINTS, transformPascalToCamel } from "@/lib/api"
import { invalidateHubCounts } from "@/lib/hub-counts-cache"
import type { ValueMappingSet } from "@/types/fbo-api"

// Session cache shared by every consumer (dialogs open often); invalidated on writes
let setsCache: Promise<ValueMappingSet[]> | null = null

export function useValueMappingSets() {
  const { mainApi } = useApi()

  const loadSets = async (): Promise<ValueMappingSet[]> => {
    if (!setsCache) {
      setsCache = mainApi
        .get<any[]>(API_ENDPOINTS.MAIN.ATS_VALUE_MAPPING_SETS)
        .then((response) => transformPascalToCamel(response) as ValueMappingSet[])
        .catch((err) => {
          // Don't cache failures
          setsCache = null
          throw err
        })
    }
    return setsCache
  }

  const saveSet = async (set: ValueMappingSet): Promise<void> => {
    await mainApi.post(API_ENDPOINTS.MAIN.ATS_VALUE_MAPPING_SETS, set)
    setsCache = null
    invalidateHubCounts()
  }

  const deleteSet = async (name: string): Promise<void> => {
    await mainApi.delete(API_ENDPOINTS.MAIN.ATS_VALUE_MAPPING_SET(name))
    setsCache = null
    invalidateHubCounts()
  }

  return { loadSets, saveSet, deleteSet }
}
